module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._m(0), _vm._v(" "), _c('div', {
    attrs: {
      "id": "wrap"
    }
  }, [_vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('div', {
    attrs: {
      "id": "content"
    }
  }, [_c('section', {
    staticClass: "shop-page padding-top-100 padding-bottom-100"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "item-display"
  }, [_c('div', {
    staticClass: "row"
  }, [_vm._v("\r\n            bb" + _vm._s(_vm.ajk) + "bb---------\r\n            "), _vm._m(3), _vm._v(" "), _vm._m(4)])]), _vm._v(" "), _c('div', {
    staticClass: "papular-block row"
  }, _vm._l((_vm.products), function(product) {
    return _c('div', {
      staticClass: "col-md-3"
    }, [_c('a', {
      attrs: {
        "href": 'products?search=' + product.product_url_name
      }
    }, [_c('div', {
      staticClass: "item"
    }, [_vm._m(5, true), _vm._v(" "), _c('div', {
      staticClass: "item-name"
    }, [_c('a', {
      attrs: {
        "href": "#."
      }
    }, [_vm._v(_vm._s(product.product_name))]), _vm._v(" "), _c('p', [_vm._v("It's " + _vm._s(product.product_name))])]), _vm._v(" "), _c('span', {
      staticClass: "price"
    }, [_c('small', [_vm._v("₦")]), _vm._v(_vm._s(product.product_price))])])])])
  }))])])]), _vm._v(" "), _vm._m(6)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "loader"
    }
  }, [_c('div', {
    staticClass: "position-center-center"
  }, [_c('div', {
    staticClass: "ldr"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', [_c('div', {
    staticClass: "sticky"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "logo"
  }, [_c('a', {
    attrs: {
      "href": "index.html"
    }
  }, [_c('img', {
    staticClass: "img-responsive",
    attrs: {
      "src": "static/assets/images/logo.png",
      "alt": ""
    }
  })])]), _vm._v(" "), _c('nav', {
    staticClass: "navbar ownmenu"
  }, [_c('div', {
    staticClass: "navbar-header"
  }, [_c('button', {
    staticClass: "navbar-toggle collapsed",
    attrs: {
      "type": "button",
      "data-toggle": "collapse",
      "data-target": "#nav-open-btn",
      "aria-expanded": "false"
    }
  }, [_c('span', {
    staticClass: "sr-only"
  }, [_vm._v("Toggle navigation")]), _vm._v(" "), _c('span', {
    staticClass: "icon-bar"
  }, [_c('i', {
    staticClass: "fa fa-navicon"
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "collapse navbar-collapse",
    attrs: {
      "id": "nav-open-btn"
    }
  }, [_c('ul', {
    staticClass: "nav"
  })]), _vm._v(" "), _c('div', {
    staticClass: "nav-right"
  }, [_c('ul', {
    staticClass: "navbar-right"
  }, [_c('li', {
    staticClass: "dropdown user-acc"
  }, [_c('a', {
    staticClass: "dropdown-toggle",
    attrs: {
      "href": "#",
      "data-toggle": "dropdown",
      "role": "button"
    }
  }, [_c('i', {
    staticClass: "icon-user"
  })]), _vm._v(" "), _c('ul', {
    staticClass: "dropdown-menu"
  }, [_c('li', [_c('h6', [_vm._v("HELLO! Jhon Smith")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("MY CART")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("ACCOUNT INFO")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("LOG OUT")])])])])])])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "sub-bnr",
    attrs: {
      "data-stellar-background-ratio": "0.5"
    }
  }, [_c('div', {
    staticClass: "position-center-center"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('h4', [_vm._v("230 Sellpoints")]), _vm._v(" "), _c('p', [_vm._v("Connect Businesses through their Sellpoints")]), _vm._v(" "), _c('ol', {
    staticClass: "breadcrumb"
  }, [_c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Start")])])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-6"
  }, [_c('span', {
    staticClass: "product-num"
  }, [_vm._v("Showing 1 - 10 of 30 products")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-6"
  }, [_c('div', {
    staticClass: "pull-right"
  }, [_c('select', {
    staticClass: "selectpicker"
  }, [_c('option', [_vm._v("Short By")]), _vm._v(" "), _c('option', [_vm._v("Short By")]), _vm._v(" "), _c('option', [_vm._v("Short By")])]), _vm._v(" "), _c('select', {
    staticClass: "selectpicker"
  }, [_c('option', [_vm._v("Filter By")]), _vm._v(" "), _c('option', [_vm._v("Short By")]), _vm._v(" "), _c('option', [_vm._v("Short By")])]), _vm._v(" "), _c('a', {
    staticClass: "grid-style",
    attrs: {
      "href": "#."
    }
  }, [_c('i', {
    staticClass: "icon-grid"
  })]), _vm._v(" "), _c('a', {
    staticClass: "list-style",
    attrs: {
      "href": "#."
    }
  }, [_c('i', {
    staticClass: "icon-list"
  })])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "item-img"
  }, [_c('img', {
    staticClass: "img-1",
    attrs: {
      "src": "static/assets/images/product-2-1.jpg",
      "alt": ""
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "img-2",
    attrs: {
      "src": "static/assets/images/product-2.jpg",
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "overlay"
  }, [_c('div', {
    staticClass: "position-center-center"
  }, [_c('div', {
    staticClass: "inn"
  }, [_c('a', {
    attrs: {
      "href": "static/assets/images/product-2-1.jpg",
      "data-lighter": ""
    }
  }, [_c('i', {
    staticClass: "icon-magnifier"
  })]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#."
    }
  }, [_c('i', {
    staticClass: "icon-basket"
  })]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#."
    }
  }, [_c('i', {
    staticClass: "icon-heart"
  })])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('footer', [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('div', {
    staticClass: "about-footer"
  }, [_c('img', {
    staticClass: "margin-bottom-30",
    attrs: {
      "src": "static/assets/images/logo-foot.png",
      "alt": ""
    }
  }), _vm._v(" "), _c('p', [_vm._v("Where you sell.")]), _vm._v(" "), _c('p', [_c('i', {
    staticClass: "icon-call-end"
  }), _vm._v(" 080000000000")]), _vm._v(" "), _c('p', [_c('i', {
    staticClass: "icon-envelope"
  }), _vm._v(" howtosell@sellpoint.ng")]), _vm._v(" "), _c('p', [_c('i', {
    staticClass: "icon-envelope"
  }), _vm._v(" howtobuy@sellpoint.ng")]), _vm._v(" "), _c('p', [_c('i', {
    staticClass: "icon-envelope"
  }), _vm._v(" info@sellpoint.ng")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('h6', [_vm._v("TOUR")]), _vm._v(" "), _c('ul', {
    staticClass: "link"
  }, [_c('li', [_c('a', {
    attrs: {
      "href": "#."
    }
  }, [_vm._v(" Sellpoints")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#."
    }
  }, [_vm._v(" Find a Sellpoint")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#."
    }
  }, [_vm._v(" Products")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#."
    }
  }, [_vm._v(" Services")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#."
    }
  }, [_vm._v(" Privacy Policy")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#."
    }
  }, [_vm._v(" Media ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('h6', [_vm._v("INFO")]), _vm._v(" "), _c('ul', {
    staticClass: "link"
  }, [_c('li', [_c('a', {
    attrs: {
      "href": "#."
    }
  }, [_vm._v(" How to sell")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#."
    }
  }, [_vm._v(" How to buy")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#."
    }
  }, [_vm._v(" Contact")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#."
    }
  }, [_vm._v(" Support")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#."
    }
  }, [_vm._v(" Career")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#."
    }
  }, [_vm._v(" Shipping Options")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#."
    }
  }, [_vm._v(" Knowledge Base")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('h6', [_vm._v("TOP LIST")]), _vm._v(" "), _c('ul', {
    staticClass: "link"
  }, [_c('li', [_c('a', {
    attrs: {
      "href": "#."
    }
  }, [_vm._v(" Food")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#."
    }
  }, [_vm._v(" Health")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#."
    }
  }, [_vm._v(" Fashion")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#."
    }
  }, [_vm._v(" Home")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#."
    }
  }, [_vm._v(" Community")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#."
    }
  }, [_vm._v(" Events")])])])]), _vm._v(" "), _c('div', {
    staticClass: "rights"
  }, [_c('p', [_vm._v("©  2015 sellpoint All right reserved. ")]), _vm._v(" "), _c('div', {
    staticClass: "scroll"
  }, [_c('a', {
    staticClass: "go-up",
    attrs: {
      "href": "#wrap"
    }
  }, [_c('i', {
    staticClass: "lnr lnr-arrow-up"
  })])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-8965dae0"}!./src/pages/Points/template.html
// module id = 292
// module chunks = 0